import { render, staticRenderFns } from "./LocalGroupAdd.vue?vue&type=template&id=4423c992&scoped=true"
import script from "./LocalGroupAdd.vue?vue&type=script&lang=js"
export * from "./LocalGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423c992",
  null
  
)

export default component.exports